import { createAction, handleActions } from 'redux-actions';
import ActionTypes from '~shared/constants/actionTypes';
import { _getServiceHistoryDetails, _getServiceHistoryNotes, _getServiceHistoryList, _getActivePetTypesList, _getServiceHistoryNotesList, _getServiceHistoryNotesByPetIdList, _addServiceHistoryNotesList, _getAllServices, _editServiceHistoryNotesList } from '~shared/httpService/apis';

const initialState = {
  service_history_list: { loading: false, response: [], hasError: false, error: {} },
  pet_types: { loading: false, response: [], hasError: false, error: {} },
  service_history_detail: { loading: false, response: {}, hasError: false, error: {} },
  service_history_notes: { loading: false, response: {}, hasError: false, error: {} },
  service_history_notes_list: { loading: false, response: {}, hasError: false, error: {} },
  service_history_notes_by_pet_id_list: { loading: false, response: {}, hasError: false, error: {} },
  add_service_history_notes_list: { loading: false, response: {}, hasError: false, error: {} },
  edit_service_history_notes_list: { loading: false, response: {}, hasError: false, error: {} },
  all_services: { loading: false, response: {}, hasError: false, error: {} },
};

export const getServiceHistoryDetailsGeneralStart = createAction(ActionTypes.GET_SERVICE_HISTORY_DETAILS);
export const getServiceHistoryDetailsGeneralSuccess = createAction(ActionTypes.GET_SERVICE_HISTORY_DETAILS_SUCCESS, response => response);
export const getServiceHistoryDetailsGeneralError = createAction(ActionTypes.GET_SERVICE_HISTORY_DETAILS_ERROR, error => error);

export const getServiceHistoryDetailsGeneral = (id) => (dispatch) => {
  dispatch(getServiceHistoryDetailsGeneralStart());
  return _getServiceHistoryDetails(id).then((response) => {

    dispatch(getServiceHistoryDetailsGeneralSuccess(response));
  }).catch((error) => {
    dispatch(getServiceHistoryDetailsGeneralError(error));
  });
};

export const getServiceHistoryNotesStart = createAction(ActionTypes.GET_SERVICE_HISTORY_NOTES);
export const getServiceHistoryNotesSuccess = createAction(ActionTypes.GET_SERVICE_HISTORY_NOTES_SUCCESS, response => response);
export const getServiceHistoryNotesError = createAction(ActionTypes.GET_SERVICE_HISTORY_NOTES_ERROR, error => error);

export const getServiceHistoryNotes = (id) => (dispatch) => {
  dispatch(getServiceHistoryNotesStart());
  return _getServiceHistoryNotes(id).then((response) => {
    dispatch(getServiceHistoryNotesSuccess(response));
  }).catch((error) => {
    dispatch(getServiceHistoryNotesError(error));
  });
};

export const getServiceHistoryNotesStartList = createAction(ActionTypes.GET_SERVICE_HISTORY_NOTES_LIST);
export const getServiceHistoryNotesSuccessList = createAction(ActionTypes.GET_SERVICE_HISTORY_NOTES_LIST_SUCCESS, response => response);
export const getServiceHistoryNotesErrorList = createAction(ActionTypes.GET_SERVICE_HISTORY_NOTES_LIST_ERROR, error => error);

export const getServiceHistoryNotesList = (id) => (dispatch) => {
  dispatch(getServiceHistoryNotesStartList());
  return _getServiceHistoryNotesList(id).then((response) => {
    dispatch(getServiceHistoryNotesSuccessList(response));
  }).catch((error) => {
    dispatch(getServiceHistoryNotesErrorList(error));
  });
};

export const getServiceHistoryNotesByPetIdStartList = createAction(ActionTypes.GET_SERVICE_HISTORY_NOTES_BY_PET_ID_LIST);
export const getServiceHistoryNotesByPetIdSuccessList = createAction(ActionTypes.GET_SERVICE_HISTORY_NOTES_BY_PET_ID_LIST_SUCCESS, response => response);
export const getServiceHistoryNotesByPetIdErrorList = createAction(ActionTypes.GET_SERVICE_HISTORY_NOTES_BY_PET_ID_LIST_ERROR, error => error);

export const getServiceHistoryNotesListByPetId = (id, page, pageSize,) => (dispatch) => {
  dispatch(getServiceHistoryNotesByPetIdStartList());
  return _getServiceHistoryNotesByPetIdList(id, page, pageSize,).then((response) => {
    dispatch(getServiceHistoryNotesByPetIdSuccessList(response));
  }).catch((error) => {
    dispatch(getServiceHistoryNotesByPetIdErrorList(error));
  });
};

export const addServiceHistoryNotesStartList = createAction(ActionTypes.ADD_SERVICE_HISTORY_NOTES_LIST);
export const addServiceHistoryNotesSuccessList = createAction(ActionTypes.ADD_SERVICE_HISTORY_NOTES_LIST_SUCCESS, response => response);
export const addServiceHistoryNotesErrorList = createAction(ActionTypes.ADD_SERVICE_HISTORY_NOTES_LIST_ERROR, error => error);

export const addServiceHistoryNotesList = (id, data) => (dispatch) => {
  dispatch(addServiceHistoryNotesStartList());
  return _addServiceHistoryNotesList(id, data).then((response) => {
    dispatch(addServiceHistoryNotesSuccessList(response));
  }).catch((error) => {
    dispatch(addServiceHistoryNotesErrorList(error));
  });
};

export const editServiceHistoryNotesStartList = createAction(ActionTypes.EDIT_SERVICE_HISTORY_NOTES_LIST);
export const editServiceHistoryNotesSuccessList = createAction(ActionTypes.EDIT_SERVICE_HISTORY_NOTES_LIST_SUCCESS, response => response);
export const editServiceHistoryNotesErrorList = createAction(ActionTypes.EDIT_SERVICE_HISTORY_NOTES_LIST_ERROR, error => error);

export const editServiceHistoryNotesList = (id, data) => (dispatch) => {
  dispatch(editServiceHistoryNotesStartList());
  return _editServiceHistoryNotesList(id, data).then((response) => {
    dispatch(editServiceHistoryNotesSuccessList(response));
  }).catch((error) => {
    dispatch(editServiceHistoryNotesErrorList(error));
  });
};


export const getServiceHistoryStart = createAction(ActionTypes.GET_SERVICE_HISTORY_LIST);
export const getServiceHistorySuccess = createAction(ActionTypes.GET_SERVICE_HISTORY_LIST_SUCCESS, response => response);
export const getServiceHistoryError = createAction(ActionTypes.GET_SERVICE_HISTORY_LIST_ERROR, error => error);

export const getServiceHistoryDetails = (page = '', pageSize, searchQuery, customerId, startDate,endDate, petType, serviceStatus, pet, service) => (dispatch) => {
  dispatch(getServiceHistoryStart());
  return _getServiceHistoryList(page, pageSize, searchQuery, customerId, startDate,endDate, petType, serviceStatus, pet, service).then((response) => {
    dispatch(getServiceHistorySuccess(response));
  }).catch((error) => {
    dispatch(getServiceHistoryError(error));
  });
};

export const getAllServicesStart = createAction(ActionTypes.GET_ALL_SERVICES);
export const getAllServicesSuccess = createAction(ActionTypes.GET_ALL_SERVICES_SUCCESS, response => response);
export const getAllServicesError = createAction(ActionTypes.GET_ALL_SERVICES_ERROR, error => error);

export const getAllServices = () => (dispatch) => {
  dispatch(getAllServicesStart());
  return _getAllServices().then((response) => {
    dispatch(getAllServicesSuccess(response));
  }).catch((error) => {
    dispatch(getAllServicesError(error));
  });
};

export const getPetActiveStart = createAction(ActionTypes.GET_ACTIVE_PET_TYPES_LIST);
export const getPetActiveSuccess = createAction(ActionTypes.GET_ACTIVE_PET_TYPES_LIST_SUCCESS, response => response);
export const getPetActiveError = createAction(ActionTypes.GET_ACTIVE_PET_TYPES_LIST_ERROR, error => error);

export const getActivePetList = (page = "", pageSize) => (dispatch) => {
  dispatch(getPetActiveStart());
  return _getActivePetTypesList(page, pageSize).then((response) => {
    dispatch(getPetActiveSuccess(response));
  }).catch((error) => {
    dispatch(getPetActiveError(error));
  });
};

const reducer = handleActions({
  //SERVICE_HISTORY_LIST
  [ActionTypes.GET_SERVICE_HISTORY_LIST]: (state) => ({
    ...state, service_history_list: {
      ...state.service_history_list,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SERVICE_HISTORY_LIST_SUCCESS]: (state, action) => ({
    ...state,
    service_history_list: {
      ...state.service_history_list,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SERVICE_HISTORY_LIST_ERROR]: (state, action) => ({
    ...state,
    service_history_list: {
      ...state.service_history_list,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),

    //SERVICE_HISTORY_LIST
    [ActionTypes.GET_ALL_SERVICES]: (state) => ({
      ...state, all_services: {
        ...state.all_services,
        loading: true, hasError: false, error: {}
      }
    }),
    [ActionTypes.GET_ALL_SERVICES_SUCCESS]: (state, action) => ({
      ...state,
      all_services: {
        ...state.all_services,
        response: action.payload, loading: false, hasError: false, error: {}
      }
    }),
    [ActionTypes.GET_ALL_SERVICES_ERROR]: (state, action) => ({
      ...state,
      all_services: {
        ...state.all_services,
        error: action.payload, loading: false, hasError: true, response: {}
      }
    }),

  //ACTIVE_PET_TYPES_LIST
  [ActionTypes.GET_ACTIVE_PET_TYPES_LIST]: (state) => ({
    ...state, pet_types: {
      ...state.pet_types,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ACTIVE_PET_TYPES_LIST_SUCCESS]: (state, action) => ({
    ...state,
    pet_types: {
      ...state.pet_types,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_ACTIVE_PET_TYPES_LIST_ERROR]: (state, action) => ({
    ...state,
    pet_types: {
      ...state.pet_types,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //SERVICE_HISTORY_DETAILS
  [ActionTypes.GET_SERVICE_HISTORY_DETAILS]: (state) => ({
    ...state, service_history_detail: {
      ...state.service_history_detail,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SERVICE_HISTORY_DETAILS_SUCCESS]: (state, action) => ({
    ...state,
    service_history_detail: {
      ...state.service_history_detail,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SERVICE_HISTORY_DETAILS_ERROR]: (state, action) => ({
    ...state,
    service_history_detail: {
      ...state.service_history_detail,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),
  //SERVICE_HISTORY_NOTES
  [ActionTypes.GET_SERVICE_HISTORY_NOTES]: (state) => ({
    ...state, service_history_notes: {
      ...state.service_history_notes,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SERVICE_HISTORY_NOTES_SUCCESS]: (state, action) => ({
    ...state,
    service_history_notes: {
      ...state.service_history_notes,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SERVICE_HISTORY_NOTES_ERROR]: (state, action) => ({
    ...state,
    service_history_notes: {
      ...state.service_history_notes,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),

   //SERVICE_HISTORY_NOTES_LIST
   [ActionTypes.GET_SERVICE_HISTORY_NOTES_LIST]: (state) => ({
    ...state, service_history_notes_list: {
      ...state.service_history_notes_list,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SERVICE_HISTORY_NOTES_LIST_SUCCESS]: (state, action) => ({
    ...state,
    service_history_notes_list: {
      ...state.service_history_notes_list,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SERVICE_HISTORY_NOTES_LIST_ERROR]: (state, action) => ({
    ...state,
    service_history_notes_list: {
      ...state.service_history_notes_list,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),

  //SERVICE_HISTORY_NOTES_PET_ID_LIST
  [ActionTypes.GET_SERVICE_HISTORY_NOTES_BY_PET_ID_LIST]: (state) => ({
    ...state, service_history_notes_by_pet_id_list: {
      ...state.service_history_notes_by_pet_id_list,
      loading: true, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SERVICE_HISTORY_NOTES_BY_PET_ID_LIST_SUCCESS]: (state, action) => ({
    ...state,
    service_history_notes_by_pet_id_list: {
      ...state.service_history_notes_by_pet_id_list,
      response: action.payload, loading: false, hasError: false, error: {}
    }
  }),
  [ActionTypes.GET_SERVICE_HISTORY_NOTES_BY_PET_ID_LIST_ERROR]: (state, action) => ({
    ...state,
    service_history_notes_by_pet_id_list: {
      ...state.service_history_notes_by_pet_id_list,
      error: action.payload, loading: false, hasError: true, response: {}
    }
  }),

    //ADD_SERVICE_HISTORY_NOTES_LIST
    [ActionTypes.ADD_SERVICE_HISTORY_NOTES_LIST]: (state) => ({
      ...state, add_service_history_notes_list: {
        ...state.add_service_history_notes_list,
        loading: true, hasError: false, error: {}
      }
    }),
    [ActionTypes.ADD_SERVICE_HISTORY_NOTES_LIST_SUCCESS]: (state, action) => ({
      ...state,
      add_service_history_notes_list: {
        ...state.add_service_history_notes_list,
        response: action.payload, loading: false, hasError: false, error: {}
      }
    }),
    [ActionTypes.ADD_SERVICE_HISTORY_NOTES_LIST_ERROR]: (state, action) => ({
      ...state,
      add_service_history_notes_list: {
        ...state.add_service_history_notes_list,
        error: action.payload, loading: false, hasError: true, response: {}
      }
    }),
    //EDIT_SERVICE_HISTORY_NOTES_LIST
    [ActionTypes.EDIT_SERVICE_HISTORY_NOTES_LIST]: (state) => ({
      ...state, edit_service_history_notes_list: {
        ...state.edit_service_history_notes_list,
        loading: true, hasError: false, error: {}
      }
    }),
    [ActionTypes.EDIT_SERVICE_HISTORY_NOTES_LIST_SUCCESS]: (state, action) => ({
      ...state,
      edit_service_history_notes_list: {
        ...state.edit_service_history_notes_list,
        response: action.payload, loading: false, hasError: false, error: {}
      }
    }),
    [ActionTypes.EDIT_SERVICE_HISTORY_NOTES_LIST_ERROR]: (state, action) => ({
      ...state,
      edit_service_history_notes_list: {
        ...state.edit_service_history_notes_list,
        error: action.payload, loading: false, hasError: true, response: {}
      }
    }),
}, initialState);

export default reducer;